export default __webpack_public_path__ + "static/media/viewOff.0fcdb39a.svg";